import StepDatosGenerales from './StepDatosGenerales/StepDatosGenerales';
import StepProfesionales from './StepProfesionales/StepProfesionales';
import StepLegales from './StepLegales/StepLegales';
import { StepDelegaciones } from './StepDelegaciones/StepDelegaciones';
import { StepClientes } from './StepClientes/StepClientes';
import { StepInsumos } from './StepInsumos/StepInsumos';
import { StepDietas } from './StepDietas/StepDietas';
import { StepFacturacion } from './StepFacturacion/StepFacturacion';

export const STEPS = [
    { stepName: 'Datos generales', status: 'ACTIVE', order: 1, component: <StepDatosGenerales /> },
    { stepName: 'Delegaciones', status: 'INACTIVE', order: 2, component: <StepDelegaciones /> },
    { stepName: 'Clientes', status: 'INACTIVE', order: 3, component: <StepClientes /> },
    { stepName: 'Facturación', status: 'INACTIVE', order: 4, component: <StepFacturacion/> },
    { stepName: 'Legales', status: 'INACTIVE', order: 5, component: <StepLegales /> },
    { stepName: 'Insumos', status: 'INACTIVE', order: 6, component: <StepInsumos /> },
    { stepName: 'Elección', status: 'INACTIVE', order: 7, component:<StepDietas/> },
    { stepName: 'Profesional', status: 'INACTIVE', order: 8, component: <StepProfesionales /> },
];

export const getStepByStatus = (order, steps) => {
    return steps?.find(step => step?.order === order && step?.status.toUpperCase() === 'ACTIVE');
};
